<template>
  <div>
    <b-alert v-model="hasUnknownError" variant="danger">
      {{ unknownErrorMessage }}
    </b-alert>

    <b-form-group>
      <b-form-select
        v-model="community"
        :options="communities"
        class="mr-3"
        :disabled="isModalEdit"
      >
        <template v-slot:first>
          <b-form-select-option :value="null">Gemeinde auswählen</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>

  </div>
</template>

<script>
  import { errorHandler } from '@/helpers/formHelper.js'

  export default {
    data: () => ({
      hasUnknownError: false,
      unknownErrorMessage: '',
      communities: []
    }),
    created () {
      this.getCommunities()
    },
    methods: {
      async getCommunities () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('community/GET_APPLICATION_COMMUNITIES').then(res => {
          const { errors, data } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          const communities = data.gemeinden

          const renamedTypes = communities.map(type => ({
            text: type.name,
            value: type.id
          }))

          this.communities = renamedTypes
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      }
    },
    props: {
      isModalEdit: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      community: {
        set (value) {
          this.$store.commit('application/SET_APPLICATION_COMMUNITY_ADVANCED', value)
          this.$store.commit('application/SET_APPLICATION_ADVANCED_TYPE', null)
        },
        get () {
          return this.$store.state.application.createApplication.advancedCommunityId
        }
      }
    }
  }
</script>
